import { memo } from 'react'
import GiftCard from './GiftCard'
import GiftCardSkeleton from './GiftCardSkeleton'

function GiftsGrid({ gifts, isLoading, error, onOpen, onPreload }) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 gap-4 auto-rows-fr">
        {Array.from({ length: 4 }, (_, index) => (
          <GiftCardSkeleton key={`skeleton-${index}`} />
        ))}
      </div>
    )
  }

  if (error) {
    return (
      <p className="rounded-2xl border border-[rgba(255,92,112,.28)] bg-[rgba(255,92,112,.10)] px-4 py-3 text-center text-[14px] font-[510] leading-4 tracking-[-0.01em] text-[#FF8A99]">
        {error}
      </p>
    )
  }

  return (
    <div className="gifts-grid-enter grid grid-cols-2 gap-4 auto-rows-fr">
      {gifts.map((gift) => (
        <GiftCard
          key={gift.id}
          gift={gift}
          onOpen={onOpen}
          onPreload={onPreload}
        />
      ))}
    </div>
  )
}

export default memo(GiftsGrid)
